const contactRoles = [
  'deliveryContactProduction',
  'deliveryContactService',
  'productionPlanner',
  'packagingEngineer',
  'MPLManager',
  'qualityManager',
  'plantManager',
  'accountManager',
  'office',
  'ITEngineer',
  'SCMAnalystCompany',
  'buyerCompany',
];

const priceTypes = [
  'all',
  'current',
  'archive',
  'future',
];

const transportationModes = [
  'Motor',
  'Air',
  'Rail',
  'Containerized Ocean',
  'Consolidation',
  'Less than truckload',
  'Expedited Truck',
];

const carriers = [
  'ILGT',
  'IMIM',
  'LRUS',
  'LTNT',
];

const asnTrackStatuses = [
  'Черновик',
  'В пути',
  'Принят консолидатором',
  'Приехал на завод',
  'Принят на заводе частично',
  'Принят на заводе полностью',
  'Отмена',
];

const asSalesReportGroupBy = {
  number: 'number',
  'dealer.code': 'dealer',
  'part.partNumber': 'part',
  '': 'no_group',
};

// eslint-disable-next-line
export { contactRoles, priceTypes, transportationModes, carriers, asnTrackStatuses, asSalesReportGroupBy };
